var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUploadFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 46,
  height: 55,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.621.5h34.265c.063 0 .122.05.122.128v10.877h10.367c.063 0 .121.051.121.129v42.738a.123.123 0 0 1-.121.128H.621a.123.123 0 0 1-.121-.128V.628C.5.55.558.5.621.5Zm.122 53.743h44.51V11.762H34.887a.124.124 0 0 1-.121-.128V.757H.743v53.486Z",
  stroke: "url(#upload-file_svg__a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M34.832.58a.116.116 0 0 1 .163 0l.002.002 10.462 10.96a.134.134 0 0 1 0 .187.115.115 0 0 1-.084.033.123.123 0 0 1-.047-.01l-.04-.027L34.83.765a.134.134 0 0 1-.025-.143l.028-.042Z",
  stroke: "url(#upload-file_svg__b)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M33.753 41.22c.063 0 .122.051.122.128v4.367a.124.124 0 0 1-.122.128H12.246a.124.124 0 0 1-.12-.128v-4.367c0-.077.057-.127.12-.127s.122.05.122.127v4.239h21.264v-4.239c0-.077.058-.127.121-.127Z",
  stroke: "url(#upload-file_svg__c)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.998 23.58c.063 0 .122.05.122.128v16.987a.124.124 0 0 1-.122.128.123.123 0 0 1-.121-.128V23.708c0-.077.058-.128.12-.128Z",
  stroke: "url(#upload-file_svg__d)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.91 23.622a.117.117 0 0 1 .166 0l7.818 7.907a.133.133 0 0 1 0 .183.116.116 0 0 1-.162 0l-7.381-7.465-.356-.36-.355.36-7.383 7.465a.117.117 0 0 1-.166 0 .134.134 0 0 1 0-.183l7.819-7.907Z",
  stroke: "url(#upload-file_svg__e)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "upload-file_svg__a",
  x1: 0,
  y1: 37,
  x2: 46,
  y2: 37,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#071389"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#071389",
  stopOpacity: 0.667
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upload-file_svg__b",
  x1: 1.5,
  y1: 12,
  x2: 46,
  y2: 12,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#071389"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#071389"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upload-file_svg__c",
  x1: 0.5,
  y1: 46,
  x2: 45.5,
  y2: 46,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#071389"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#071389"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upload-file_svg__d",
  x1: 1.5,
  y1: 41,
  x2: 45.5,
  y2: 41,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#071389"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#071389"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upload-file_svg__e",
  x1: 2,
  y1: 32,
  x2: 45.5,
  y2: 32,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#071389"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#071389"
})))));
export { SvgUploadFile as ReactComponent };
export default __webpack_public_path__ + "/assets/81fc48839137ca873680a7ba7989dae2.svg";